import { Alert, AlertDescription } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { AlertCircle, RefreshCw } from "lucide-react";

interface InlineErrorProps {
  message: string;
  onRetry: () => void;
}

export const InlineError = ({ message, onRetry }: InlineErrorProps) => {
  return (
    <Alert className="bg-red-500/10 border-red-500/20 text-red-300">
      <AlertCircle className="h-4 w-4" />
      <AlertDescription className="flex items-center justify-between">
        <span>{message}</span>
        <Button
          variant="outline"
          size="sm"
          onClick={onRetry}
          className="ml-4 border-red-500/30 text-red-300 hover:bg-red-500/10"
        >
          <RefreshCw className="w-4 h-4 mr-2" />
          Retry
        </Button>
      </AlertDescription>
    </Alert>
  );
};